// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe,
video {
  max-width: 300px;
  width: 100%;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/news-feed/news-feed-item-content/news-feed-item-content-media-bank/news-feed-item-content-media-bank.component.scss"],"names":[],"mappings":"AAAA;;EAEI,gBAAA;EACA,WAAA;EACA,iBAAA;AACJ","sourcesContent":["iframe,\r\nvideo {\r\n    max-width: 300px;\r\n    width: 100%;\r\n    margin-right: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
